import React from 'react';
import { Chip, Typography } from '@mui/material';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import { cents, money } from '../utils/transactionSelection';

// Presentation only: the underlying transaction remains a signed outflow.
export const giftColor = theme => theme.palette.mode === 'dark' ? '#d8b4ec' : '#6b4a80';

export function GiftSentChip({ sx }) {
  return <Chip size="small" label="Gift sent" variant="outlined"
    sx={[{ color: giftColor, borderColor: 'currentColor' }, sx]} />;
}

export function GiftAmount({ amount, signed = false, variant = 'inherit', sx }) {
  const value = cents(amount);
  return <Typography component="span" variant={variant} fontWeight="bold"
    sx={[{ color: giftColor, display: 'inline-flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }, sx]}>
    <RedeemOutlinedIcon fontSize="small" aria-hidden="true" />
    {money(signed ? value : value < 0n ? -value : value)}
  </Typography>;
}
